export const SHIPMENTS_GET_SAVED_FILTERVIEWS_REQUEST = 'SHIPMENTS_GET_SAVED_FILTERVIEWS_REQUEST';
export const SHIPMENTS_GET_SAVED_FILTERVIEWS_SUCCESS = 'SHIPMENTS_GET_SAVED_FILTERVIEWS_SUCCESS';
export const SHIPMENTS_SAVE_NEW_FILTERVIEW_REQUEST = 'SHIPMENTS_SAVE_NEW_FILTERVIEW_REQUEST';
export const SHIPMENTS_SAVE_NEW_FILTERVIEW_SUCCESS = 'SHIPMENTS_SAVE_NEW_FILTERVIEW_SUCCESS';
export const SHIPMENTS_SAVE_EXISTING_FILTERVIEW_REQUEST = 'SHIPMENTS_SAVE_EXISTING_FILTERVIEW_REQUEST';
export const SHIPMENTS_SAVE_EXISTING_FILTERVIEW_SUCCESS = 'SHIPMENTS_SAVE_EXISTING_FILTERVIEW_SUCCESS';
export const SHIPMENTS_DELETE_FILTERVIEW_REQUEST = 'SHIPMENTS_DELETE_FILTERVIEW_REQUEST';
export const SHIPMENTS_DELETE_FILTERVIEW_SUCCESS = 'SHIPMENTS_DELETE_FILTERVIEW_SUCCESS';

export const SHIPMENTS_SWITCH_FILTERVIEW = 'SHIPMENTS_SWITCH_FILTERVIEW';
export const SHIPMENTS_AUTOSWITCH_FILTERVIEW_DEFAULT = 'SHIPMENTS_AUTOSWITCH_FILTERVIEW_DEFAULT';
export const SHIPMENTS_AUTOSWITCH_FILTERVIEW_CUSTOM = 'SHIPMENTS_AUTOSWITCH_FILTERVIEW_CUSTOM';

export const SHIPMENTS_CHANGE_CUSTOM_FILTERVIEW_PROP = 'SHIPMENTS_CHANGE_CUSTOM_FILTERVIEW_PROP';
export const SHIPMENTS_CHANGE_DEFAULT_FILTERVIEW_PROP = 'SHIPMENTS_CHANGE_DEFAULT_FILTERVIEW_PROP';

export const SHIPMENTS_CHANGE_FILTERVIEW_PROP = 'SHIPMENTS_CHANGE_FILTERVIEW_PROP';

export const LAUNCH_SHIPPING_SAVE_VIEW_MODAL = 'LAUNCH_SHIPPING_SAVE_VIEW_MODAL';
export const LAUNCH_SHIPPING_EDIT_VIEW_MODAL = 'LAUNCH_SHIPPING_EDIT_VIEW_MODAL';
export const LAUNCH_SHIPPING_DELETE_VIEW_MODAL = 'LAUNCH_SHIPPING_DELETE_VIEW_MODAL';

export const changeCustomFilterViewProp = (propName, propValue) => ({
  type: SHIPMENTS_CHANGE_CUSTOM_FILTERVIEW_PROP,
  propName,
  propValue,
});

export const changeFilterViewProp = (filterViewId, propName, propValue) => ({
  type: SHIPMENTS_CHANGE_FILTERVIEW_PROP,
  filterViewId,
  propName,
  propValue,
});

export const autoSwitchFilterViewToCustom = (appliedFilters, filterView) => ({
  type: SHIPMENTS_AUTOSWITCH_FILTERVIEW_CUSTOM,
  appliedFilters,
  filterView,
});

export const autoSwitchFilterViewToDefault = () => ({
  type: SHIPMENTS_AUTOSWITCH_FILTERVIEW_DEFAULT,
});

export const switchActiveFilterView = (filterViewId) => ({
  type: SHIPMENTS_SWITCH_FILTERVIEW,
  filterViewId,
});

export const getSavedFilterViewsRequest = () => ({
  type: SHIPMENTS_GET_SAVED_FILTERVIEWS_REQUEST,
});

export const getSavedFilterViewsSuccess = (savedFilterViews) => ({
  type: SHIPMENTS_GET_SAVED_FILTERVIEWS_SUCCESS,
  savedFilterViews,
});

export const saveNewFilterViewRequest = (filterView) => ({
  type: SHIPMENTS_SAVE_NEW_FILTERVIEW_REQUEST,
  filterView,
});

export const saveNewFilterViewSuccess = (filterView) => ({
  type: SHIPMENTS_SAVE_NEW_FILTERVIEW_SUCCESS,
  filterView,
});

export const saveExistingFilterViewRequest = (filterView) => ({
  type: SHIPMENTS_SAVE_EXISTING_FILTERVIEW_REQUEST,
  filterView,
});

export const saveExistingFilterViewSuccess = (filterView) => ({
  type: SHIPMENTS_SAVE_EXISTING_FILTERVIEW_SUCCESS,
  filterView,
});

export const deleteFilterViewRequest = (filterView) => ({
  type: SHIPMENTS_DELETE_FILTERVIEW_REQUEST,
  filterView,
});

export const deleteFilterViewSuccess = (filterView) => ({
  type: SHIPMENTS_DELETE_FILTERVIEW_SUCCESS,
  filterView,
});

export const launchSaveViewModal = () => ({
  type: LAUNCH_SHIPPING_SAVE_VIEW_MODAL,
});

export const launchEditViewModal = () => ({
  type: LAUNCH_SHIPPING_EDIT_VIEW_MODAL,
});

export const launchDeleteViewModal = () => ({
  type: LAUNCH_SHIPPING_DELETE_VIEW_MODAL,
});
